import React, { useState, useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import Input from "./parts/Input";
import classNames from "classnames";
import {
  deposit,
  withdraw,
  weiToEth,
  isErc20Approved,
  approveErc20,
} from "../apis/blockchain";
import { Web3Context } from "../contexts/Web3Context";
import CrossCloseButton from "./parts/CrossCloseButton";

export default function () {
  const [modal, setModal] = useState("deposit");
  const [isApprovedCheck, setIsApprovedCheck] = useState(false);
  const type = useSelector((state) => state.modal.data.type);
  const pid = useSelector((state) => state.modal.data.pid);
  const lpToken = useSelector((state) => state.modal.data.lpToken);
  const depositAmount = useSelector((state) => state.modal.data.farming);
  const name = useSelector((state) => state.modal.data.name);
  const img = useSelector((state) => state.modal.data.img);
  const rewardsCycle = useSelector((state) => state.modal.data.rewardsCycle);
  const [value, setValue] = useState(0);
  const [max, setMax] = useState(0);
  const changeHandler = (e) => setValue(e.target.value);

  const [isApproved, setIsApproved] = useState(false);

  const web3Context = useContext(Web3Context);

  const submit = async (e) => {
    e.preventDefault();

    if (type === "deposit") {
      if (isApproved) {
        await deposit(web3Context.web3.rAskoFarmContract, pid, value);
      } else {
        await approveErc20(
          web3Context.web3.web3Provider,
          lpToken.address,
          web3Context.web3.rAskoSwapRouterContract.address
        );
        setIsApproved(true);
      }
    } else {
      await withdraw(web3Context.web3.rAskoFarmContract, pid, value);
    }

    window.location.reload(false);
  };

  const init = async () => {
    if (web3Context.currentAccountAddress) {
      const approved = await isErc20Approved(
        web3Context.web3.web3Provider,
        lpToken.address,
        web3Context.currentAccountAddress,
        web3Context.web3.rAskoSwapRouterContract.address
      );
      setIsApproved(approved);

      const bal = await lpToken.balanceOf(web3Context.currentAccountAddress);
      setMax(weiToEth(bal));
    }
  };

  useEffect(() => {
    init();
  }, [web3Context]);

  const handleMax = () => {
    if (type === "deposit") {
      setValue(max);
    } else {
      setValue(depositAmount);
    }
  };

  return (
    <div className="modal modal_w550 farm-modal approve_modal">
      <CrossCloseButton className="custom-cross-btn_black close_btn" />
      <header className="modal-header">
        <div className="modal-header__currency">
          <img src={img} alt="icon" />
          <span>{name}</span>
        </div>
        <div className="modal-header__controls">
          <button
            className={classNames("custom-gradient-btn", {
              active: modal === "deposit",
            })}
            onClick={() => setModal("deposit")}
          >
            <span>Deposit</span>
          </button>

          <button
            className={classNames("custom-gradient-btn", {
              active: modal === "approve",
            })}
            onClick={() => setModal("approve")}
          >
            <span>Approve</span>
          </button>
        </div>
      </header>
      {modal === "deposit" ? (
        <form className="farm-modal-form">
          <div className="farm-modal__title">
            <span className="modal-form__suptext">Deposit Amount</span>
            <span className="modal-form__suptext modal-form__suptext_gray">
              Total balance: {max}
            </span>
          </div>
          <div className="modal-form__field farm-modal__field">
            <Input
              type="number"
              value={value}
              onChange={changeHandler}
              name="deposit"
              placeholder="0.00"
              maxEnable
              maxHandler={handleMax}
            />
          </div>
          <button
            onClick={submit}
            className="custom-gradient-btn custom-gradient-btn_inverse farm-modal__btn farm-modal__btn_mt"
          >
            <span>Deposit</span>
          </button>
        </form>
      ) : (
        <>
          <p>
            By approving this transaction you agree to a{" "}
            <span>{rewardsCycle}</span> time lock of your LP Tokens in order to
            earn rewards.
          </p>
          <form className="farm-modal-form">
            <div className="approve_modal_main">
              <label
                htmlFor={"approved_check"}
                className="v-form__label"
                onChange={() => setIsApprovedCheck(!isApprovedCheck)}
              >
                <input
                  type="checkbox"
                  name="check-test"
                  id={"approved_check"}
                  className="v-form__hidden"
                  checked={isApprovedCheck}
                />
                <div className="v-form__checkbox"></div>I agree
              </label>
              <button className="custom-gradient-btn custom-gradient-btn_inverse farm-modal__btn">
                <span>Approve</span>
              </button>
            </div>
          </form>
        </>
      )}
    </div>
  );
}
